(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row/assets/javascripts/extensions/ball-row-winplan.js') >= 0) return;  svs.modules.push('/components/tur/ball-row/assets/javascripts/extensions/ball-row-winplan.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.row = svs.tur.ball.row || {};
svs.tur.ball.row.extensions = svs.tur.ball.row.extensions || {};
class WinPlan extends svs.tur.Base {
  constructor(_ref) {
    let title = _ref.title,
      description = _ref.description;
    super({
      className: 'ball-row-winplan'
    });
    this.createDomElements();
    this._history = [];
    this.set({
      title,
      description
    });
  }
  createDomElements() {
    this.$inner = this.createAndAddElement({
      className: 'inner'
    });
  }
  classNames() {
    return ['ball-row-winplan-default'];
  }
  render() {
    return this.$el;
  }
  set(_ref2) {
    let title = _ref2.title,
      description = _ref2.description;
    this._title = title;
    this._description = description;
    this._history.push({
      title,
      description
    });
    this.$inner.innerHTML = "<span class=\"f-bold\"> ".concat(this._title, "</span> ").concat(this._description);
  }
  reset() {
    this.$inner.innerHTML = "<span class=\"f-bold\"> ".concat(this._history[0].title, "</span> ").concat(this._history[0].description);
  }
  update(_ref3) {
    let title = _ref3.title,
      description = _ref3.description;
    if (this._title === title && this._description === description) {
      return;
    }
    this._title = title;
    this._description = description;
    const tl = gsap.timeline();
    tl.to(this.$inner, 0.2, {
      y: '100%'
    });
    tl.call(() => {
      this.set({
        title,
        description
      });
    });
    tl.set(this.$inner, {
      y: '-100%'
    });
    tl.to(this.$inner, 0.2, {
      y: '0%'
    });
  }
}
svs.tur.ball.row.extensions.WinPlan = WinPlan;

 })(window);